<div class="cb-margin-top start-center flex-row">
    <h3 class="mat-headline-6 flex">Design Complexities</h3>
    <button mat-raised-button (click)="newItemClicked()" color="primary">
        Add New Design Complexity
    </button>
</div>
<cb-table class="cb-margin-top" [loaded]="true" [stringColumns]="columns" [maxHeightOffset]="256">
    @for (result of searchResults; track result) {
        <tr cbTableRow>
            <cb-td-text [value]="result.complexity"></cb-td-text>
            <cb-td-text [value]="result.targetWorkHours"></cb-td-text>
            <cb-td-text [value]="result.targetCompletionHours"></cb-td-text>
            <cb-td-checkbox [value]="result.isActive"></cb-td-checkbox>
            <td cbTableStickyCol="end" cbTableShrinkCol>
                <button mat-icon-button (click)="editItemClickedForDto(result)">
                    <mat-icon> edit </mat-icon>
                </button>
            </td>
        </tr>
    }
</cb-table>
